import React from 'react';
import { Button } from '@mui/material';
import { Replay as ReplayIcon } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateRefundMutation } from '../../../../services/RefundService';
import { clearBackupAction as clearBackup } from '../../../../services/RefundService/slice';
import { useNavigate } from 'react-router-dom';

interface ResubmitButtonProps {
  onError?: (message: string) => void;
}

export const ResubmitButton: React.FC<ResubmitButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentRefund } = useAppSelector(state => state.refund);
  const [updateRefundMutation, { isLoading }] = useUpdateRefundMutation();

  const isVisible = currentRefund?.status === 'REJECT';

  if (!isVisible) return null;

  const handleResubmit = async () => {
    if (!currentRefund) return;

    // Reset approvals when resubmitting
    const refundForResubmit = {
      ...currentRefund,
      status: 'APPROVE',
      approvals: [] // Clear previous approvals
    };

    try {
      await updateRefundMutation({ refundView: refundForResubmit }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to resubmit refund. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<ReplayIcon />}
      onClick={handleResubmit}
      disabled={isLoading}
      sx={{
        backgroundColor: '#d97706',
        '&:hover': {
          backgroundColor: '#b45309',
        },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Resubmitting...' : 'Resubmit'}
    </Button>
  );
};
